import styled, { css } from "../../__compat__/styled-components/main.entry.mjs.mjs";
import { injectSpacing } from "../../api/spacing/injectSpacing.mjs.mjs";
import { injectOSXFontSmoothing } from "../../utils/injectOSXFontSmoothing.mjs.mjs";
import { injectTypography } from "../../utils/injectTypography.mjs.mjs";
import { cssPostfix } from "../../utils/cssPostfix.mjs.mjs";
export const listClassName = `list-${cssPostfix}`;
const dynamicSpacingLarge = (props) => {
    switch (props.textVariant) {
        case 'copy1':
            return `var(${props.theme.responsive.spacing.m})`;
        case 'copy2':
            return `var(${props.theme.responsive.spacing.s})`;
        case 'copy3':
            return `var(${props.theme.responsive.spacing.s})`;
        default:
            return `var(${props.theme.responsive.spacing.m})`;
    }
};
const dynamicSpacingMedium = (props) => {
    switch (props.textVariant) {
        case 'copy1':
            return `var(${props.theme.responsive.spacing.s})`;
        case 'copy2':
            return `var(${props.theme.responsive.spacing.xs})`;
        case 'copy3':
            return `var(${props.theme.responsive.spacing.xs})`;
        default:
            return `var(${props.theme.responsive.spacing.s})`;
    }
};
const BaseListStyles = css `
  --list-padding-inline-start: var(
    --nested-list-padding-inline-start,
    calc(${dynamicSpacingLarge} * 2)
  );

  --list-item-padding-inline-end: ${dynamicSpacingMedium};

  --list-item-margin-block-start: var(
    --nested-item-margin-block-start,
    ${dynamicSpacingLarge}
  );

  --list-item-margin-block-end: var(
    --nested-item-margin-block-end,
    ${dynamicSpacingLarge}
  );

  margin: 0;

  padding-inline-start: var(--list-padding-inline-start);

  ${injectSpacing('margin')}

  ${(props) => injectTypography(props, props.textVariant)}

  counter-reset: section;

  .${listClassName} {
    --nested-list-padding-inline-start: ${dynamicSpacingLarge};
    --nested-item-margin-block-start: ${dynamicSpacingMedium};
    --nested-item-margin-block-end: ${dynamicSpacingMedium};
  }
`;
const BaseListItemStyles = css `
  position: relative;

  color: var(${(props) => props.theme.colors.ui.secondary});

  list-style: none;

  ${injectOSXFontSmoothing(true)}

  margin-block-end: var(--list-item-margin-block-end);
  margin-block-start: var(--list-item-margin-block-start);

  &:first-child {
    margin-block-start: 0;
  }

  &:last-child {
    margin-block-end: 0;
  }

  &::before {
    position: absolute;
    left: 0;
    padding-inline-end: var(--list-item-padding-inline-end);

    color: var(${(props) => props.theme.colors.ui.tertiary});

    transform: translateX(-100%);

    content: var(--counter-content);
    counter-increment: section;
  }
`;
export const StyledListItem = styled.li.withConfig({ displayName: "auir-611444a-StyledListItem", componentId: "auir-611444a-1p8hdh5" }) `
  ${BaseListItemStyles}
`;
export const StyledListUnordered = styled.ul.withConfig({ displayName: "auir-611444a-StyledListUnordered", componentId: "auir-611444a-2h5cgv" }) `
  ${BaseListStyles}

  ${StyledListItem} > & {
    margin-block-start: var(--list-item-margin-block-start);
  }

  ${StyledListItem} &:last-child {
    margin-block-end: var(--list-item-margin-block-end);
  }

  --counter-content: '${(props) => (props.variant === 'bullet' ? '›' : '')}';
`;
export const StyledListOrdered = styled.ol.withConfig({ displayName: "auir-611444a-StyledListOrdered", componentId: "auir-611444a-njawo7" }) `
  ${BaseListStyles}

  ${StyledListItem} > & {
    margin-block-start: var(--list-item-margin-block-start);
  }

  ${StyledListItem} &:last-child {
    margin-block-end: var(--list-item-margin-block-end);
  }

  --counter-content: counters(section, '.', ${(props) => props.variant}) '.';
`;
//# sourceMappingURL=List.styles.mjs.mjs.map